export enum DisplayMode {
  EDIT="DISPLAY_MODE/EDIT",
  EDIT_FULL="DISPLAY_MODE/EDIT_FULL",
  FACULTY="DISPLAY_MODE/FACULTY",
  STUDENT="DISPLAY_MODE/STUDENT",
}

export function displayTraitsBasedOnMode(displayMode: DisplayMode) {
  switch (displayMode) {
    case DisplayMode.EDIT:
      return {
        isUnlocked: true,
        isForcedUncollapsed: false,
        isEditDisplayMode: true,
      };
    case DisplayMode.EDIT_FULL:
      return {
        isUnlocked: true,
        isForcedUncollapsed: true,
        isEditDisplayMode: true,
      };
    case DisplayMode.FACULTY:
      return {
        isUnlocked: true,
        isForcedUncollapsed: false,
        isEditDisplayMode: false,
      };
    case DisplayMode.STUDENT:
    default:
      return {
        isUnlocked: false,
        isForcedUncollapsed: false,
        isEditDisplayMode: false,
      };
  }
}

export function displayModeDisplayName(displayMode: DisplayMode) {
  return ({
    [DisplayMode.EDIT]: "Edit",
    [DisplayMode.EDIT_FULL]: "Edit (Full)",
    [DisplayMode.STUDENT]: "Student Preview",
    [DisplayMode.FACULTY]: "Faculty Preview",
  } as const)[displayMode];
}
